module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "preface03"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  }, [_c('strong', [_vm._v("Leaf and Flower Terminology")])])]), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  }), _c('p', {
    staticClass: "imagen"
  }, [_c('a', {
    attrs: {
      "id": "page_xx"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img-1.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_xxi"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img-2.jpg",
      "width": "550px"
    }
  })])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img-3a.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }, [_c('p', {
    staticClass: "imagen"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img-3b.jpg",
      "width": "550px"
    }
  })])]), _c('div', {
    staticStyle: {
      "height": "550px"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "100%",
      "src": "images/fxxiii-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxiv"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fxxiv-01.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_xxiv"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_xxiv"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxv"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fxxiv-06.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_xxv"
    }
  }), _c('div', {
    staticStyle: {
      "height": "550px",
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xxv"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxvi"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "100%",
      "src": "images/f0xxv-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_xxvi"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_xxvi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxvii"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fxxvi-01a.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_xxvii"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "550px",
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "100%",
      "src": "images/fxxvi-01b.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "550px",
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "100%",
      "src": "images/img-4.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40351a15","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/preface03.vue
// module id = 66
// module chunks = 0